import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import Cookies from 'js-cookie';
import { ITill } from '../@types/till';
import { MockDataService } from '../services/mockData.service';

interface TillStore {
  tillData: ITill[];
  ordersFromDispense: any[];
  sendToTill: (data: ITill) => void;
  setOrdersFromDispense: (orders: any[]) => void;
  addOrderFromDispense: (order: any) => void;
  removeFromTill: (id: string) => void; // ✅ Added delete method
  getMockDataForPatient: (user: any) => void; // ✅ Added mock data method for patients
}

const COOKIE_KEY = 'till_data';

const useTillStore = create<TillStore>()(
  persist(
    (set, get) => ({
      tillData: [],
      ordersFromDispense: [],

      sendToTill: (data) => {
        const currentData = get().tillData;

        const existingIndex = currentData.findIndex(item => item.id === data.id);

        const tillData = {
          ...data,
          date: data.date instanceof Date ? data.date : new Date(data.date)
        };

        if (existingIndex >= 0) {
          const updatedData = [...currentData];
          updatedData[existingIndex] = tillData;
          set({ tillData: updatedData });
        } else {
          set({ tillData: [...currentData, tillData] });
        }
      },

      setOrdersFromDispense: (orders) => {
        set({ ordersFromDispense: orders });
      },

      addOrderFromDispense: (order) => {
        const currentOrders = get().ordersFromDispense;
        set({ ordersFromDispense: [...currentOrders, order] });
      },

      // ✅ New delete method
      removeFromTill: (id) => {
        const numericId = typeof id === 'string' ? Number(id) : id;
        const currentData = get().tillData;
        const updatedData = currentData.filter(item => item.id !== numericId);
        set({ tillData: updatedData });
      },

      // ✅ Mock data method for patient users
      getMockDataForPatient: (user) => {
        if (user?.roleId === 'patient') {
          const mockData = MockDataService.getMockTillData(user);
          set({ tillData: mockData });
        }
      },
    }),
    {
      name: COOKIE_KEY,
      storage: {
        getItem: (key) => {
          const item = Cookies.get(key);
          if (!item) return null;

          const parsed = JSON.parse(item);

          if (parsed.state?.tillData) {
            parsed.state.tillData = parsed.state.tillData.map((till: any) => ({
              ...till,
              date: new Date(till.date)
            }));
          }

          return parsed;
        },
        setItem: (key, value) => {
          Cookies.set(key, JSON.stringify(value), {
            expires: 7,
            secure: process.env.NODE_ENV === 'production',
            sameSite: 'strict'
          });
        },
        removeItem: (key) => Cookies.remove(key),
      },
    }
  )
);

export default useTillStore;
